import { Box } from "@mui/material";

const Logo = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mb: 0.5,
        bgcolor: "transparent",
        background: "transparent",
        position: "relative",
        overflow: "visible",
      }}
    >
      {/* title - mobile */}
      <Box
        sx={{
          display: { xs: "block", sm: "none" },
          bgcolor: "transparent",
          background: "transparent",
          position: "relative",
          overflow: "visible",
        }}
      >
        {/* beta */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: -186,
            zIndex: 0,
            pointerEvents: "none",
            overflow: "visible",
          }}
        >
          <img
            src="/longB.png"
            alt="Background Decorative"
            style={{
              width: "1000px",
              maxWidth: "1000px",
              height: "auto",
              objectFit: "cover",
              opacity: 0.3,
              position: "relative",
              left: -240,
              top: 0,
              userSelect: "none",
            }}
            draggable={false}
          />
        </Box>
        <img
          src={"serpscience.png"}
          alt="Logo"
          style={{
            width: "70%",
            objectFit: "contain",
            marginTop: 20,
            marginLeft: 70,
            background: "transparent",
            position: "relative",
            zIndex: 1,
          }}
        />
      </Box>
      
      {/* title - desktop */}
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          bgcolor: "transparent",
          background: "transparent",
          position: "relative",
          overflow: "visible",
        }}
      >
        {/* beta */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: -560,
            zIndex: 0,
            pointerEvents: "none",
            overflow: "visible",
          }}
        >
          <img
            src={"longB.png"}
            alt="Background Decorative"
            style={{
              width: "1000px",
              maxWidth: "1000px",
              height: "auto",
              objectFit: "cover",
              opacity: 0.3,
              position: "relative",
            //   left: 0,
              userSelect: "none",
            }}
            draggable={false}
          />
        </Box>
        <img
          src={"serpell.png"}
          alt="Logo"
          style={{
            width: "50%",
            objectFit: "contain",
            marginTop: 20,
            background: "transparent",
            position: "relative",
            zIndex: 1,
          }}
        />
        <img
          src={"science.png"}
          alt="Logo"
          style={{
            width: "50%",
            objectFit: "contain",
            marginTop: 20,
            background: "transparent",
            position: "relative",
            zIndex: 1,
          }}
        />
      </Box>
    </Box>
  );
};

export default Logo;